import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '../context/ThemeContext';
import { STRIPE_PAYMENT_LINK } from '../config/stripe';
import { trackDonationClick } from '../utils/analytics';

const MartiniBanner: React.FC = () => {
  const { isDark } = useTheme();

  return (
    <Box
      component="a"
      href={STRIPE_PAYMENT_LINK}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackDonationClick()}
      sx={{
        display: 'block',
        mt: 10,
        mb: 8,
        py: { xs: 5, md: 6 },
        px: { xs: 4, md: 6 },
        mx: { xs: -3, md: 0 },
        background: isDark 
          ? 'linear-gradient(165deg, #1a1612 0%, #0f0f0f 100%)'
          : 'linear-gradient(165deg, #faf8f5 0%, #f5f0eb 100%)',
        borderTop: `1px solid ${isDark ? '#2a2420' : '#e8e0d8'}`,
        borderBottom: `1px solid ${isDark ? '#2a2420' : '#e8e0d8'}`,
        textDecoration: 'none',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.4s ease',
        '&:hover': {
          background: isDark 
            ? 'linear-gradient(165deg, #1f1a15 0%, #121212 100%)'
            : 'linear-gradient(165deg, #fdfbf8 0%, #f8f4ef 100%)',
          '& .glass-left': {
            transform: 'rotate(15deg) translateX(4px)',
          },
          '& .glass-right': {
            transform: 'rotate(-15deg) scaleX(-1) translateX(4px)',
          },
          '& .cta-text': {
            letterSpacing: '0.15em',
          },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          gap: { xs: 0.5, md: 1 },
          mb: 2.5,
          height: { xs: '4rem', md: '5rem' },
        }}
      >
        <Box
          className="glass-left"
          sx={{
            fontSize: { xs: '2.8rem', md: '3.5rem' },
            display: 'inline-block',
            transition: 'transform 0.3s ease',
            transform: 'rotate(0deg)',
          }}
        >
          🍸
        </Box>
        <Box
          className="glass-right"
          sx={{
            fontSize: { xs: '2.8rem', md: '3.5rem' },
            display: 'inline-block',
            transition: 'transform 0.3s ease',
            transform: 'rotate(0deg) scaleX(-1)',
          }}
        >
          🍸
        </Box>
      </Box>

      <Typography
        sx={{
          fontSize: { xs: '0.7rem', md: '0.75rem' },
          fontWeight: 500,
          color: isDark ? '#8a7b6b' : '#9a8b7b',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          mb: 1.5,
        }}
      >
        Support the author
      </Typography>

      <Typography
        className="cta-text"
        sx={{
          fontSize: { xs: '1.4rem', md: '1.6rem' },
          fontWeight: 300,
          color: isDark ? '#e8ddd0' : '#3a3530',
          letterSpacing: '0.08em',
          transition: 'letter-spacing 0.4s ease',
        }}
      >
        Buy me a martini
      </Typography>

      <Typography
        sx={{
          fontSize: { xs: '0.85rem', md: '0.9rem' },
          fontWeight: 300,
          color: isDark ? '#6a5f55' : '#9a908a',
          mt: 1.5,
          fontStyle: 'italic',
        }}
      >
        Don't be shy
      </Typography>
    </Box>
  );
};

export default MartiniBanner;
